import React from 'react'
import {FaGlobe, FaClock} from 'react-icons/fa'
import DataCard from './DataCard'

function GlobalData({MyGlobalData, LoadingState, LastUpdate}) {
  const {
    NewConfirmed,
    TotalConfirmed,
    NewDeaths,
    TotalDeaths,
    NewRecovered,
    TotalRecovered,
  } = MyGlobalData
  const Active = TotalConfirmed - TotalRecovered - TotalDeaths

  return (
    <div className="global-box d-flex flex-column align-items-center mt-5">
      <div className="global-title d-flex">
        <FaGlobe className="mt-1 pt-1 mr-1" size="1.2rem" />
        <div>Global Statistics</div>
      </div>
      <div className="container-fluid d-flex flex-md-fill flex-column flex-md-row justify-content-around align-items-center align-items-md-start align-items-lg-start">
        <DataCard
          ID={1}
          IsLoading={LoadingState}
          Title="Confirmed"
          Data={[NewConfirmed, TotalConfirmed]}
          color="rgb(255,0,0)"
        />
        <DataCard
          ID={2}
          IsLoading={LoadingState}
          Title="Active"
          Data={[0, Active]}
          color="rgba(74, 127, 180, 0.7)"
        />
        <DataCard
          ID={3}
          IsLoading={LoadingState}
          Title="Recovered"
          Data={[NewRecovered, TotalRecovered]}
          color="rgb(0,255,0)"
        />
        <DataCard
          ID={4}
          IsLoading={LoadingState}
          Title="Deaths"
          Data={[NewDeaths, TotalDeaths]}
          color="rgb(255,255,255,0.5)"
        />
      </div>
      <div className="text-light">
        <FaClock className="mb-1" size="1.2rem" />
        Last Update: {new Date(LastUpdate).toLocaleString()}
      </div>
    </div>
  )
}

export default GlobalData
